"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _stylitas = require("@creditas/stylitas");

var _sizes = require("./sizes");

var builder = function builder(theme, name) {
  var upperCaseName = name.toUpperCase();
  var family = theme["font".concat(upperCaseName, "Family")];
  var size = theme["font".concat(upperCaseName, "Size")];
  var lineHeight = theme["font".concat(upperCaseName, "LineHeight")];
  var letterSpacing = theme["font".concat(upperCaseName, "Spacing")];
  return "font-family: ".concat(family, ";\n    font-size: ").concat(size, ";\n    line-height: ").concat(lineHeight, ";\n    letter-spacing: ").concat(letterSpacing, ";");
};

var styles = _sizes.sizes.reduce(function (acc, size) {
  acc[size] = function (theme) {
    return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), builder(theme, size));
  };

  acc[size.toUpperCase()] = function (theme) {
    return (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), builder(theme, size));
  };

  return acc;
}, {});

exports.styles = styles;